/**
 * Ensures a URL has an HTTP protocol prefix.
 * If the URL already starts with http:// or https://, it's returned unchanged.
 * Otherwise, http:// is prepended to the URL.
 *
 * @param url - The URL to process
 * @returns The URL with http:// prefix, or undefined if input is undefined/empty
 * @example
 * ensureHttpPrefix("example.com") // returns "http://example.com"
 * ensureHttpPrefix("https://example.com") // returns "https://example.com"
 * ensureHttpPrefix(undefined) // returns undefined
 */
function ensureHttpPrefix(url: string | undefined): string | undefined {
    if (!url) return undefined;
    return /^https?:\/\//i.test(url) ? url : `http://${url}`;
}

export { ensureHttpPrefix };
